import React, { FC } from 'react'

import { Images } from '../../../product/selector/components/images'
import { ArrowNext,ArrowPrev,Close } from './../../icons/index'

export type Author = {
  author?: string
  material?: string
  finish_url?: string
  style?: string
  style_url?: string
  product_url?: string
}

export type Inspiration = {
  inspiration?: Author
}

export type Tag = {
  finish?: string
}

export type Prod = {
  id: string
  title?: string
  image?: string
  named_tags?: Tag
  meta?: Inspiration
}

export type Props = {
  product: Prod
  state: boolean
  all_items_no: number
  closeModal: () => void
  no: number
  goToPrevCard: (val: number) => void
  goToNextCard: (val: number) => void
}

export const Modal: FC<Props> = ({
  product,
  state,
  closeModal,
  all_items_no,
  no,
  goToPrevCard,
  goToNextCard
}) => {

  function closeModalFunction() {
    closeModal()
  }

  function goToPrev() {
    closeModal()
    goToPrevCard(no - 1)
  }

  function goToNext() {
    closeModal()
    goToNextCard(no + 1)
  }

  return (
    <div>
      <div
        className={`ProductModal-overlay ${state === true ? 'open' : ''}`}
      ></div>

      {no !== 0 ? (
        <div
          className={`ProductModal-arrowLeft ${state === true ? 'open' : ''}`}
          onClick={goToPrev}
        >
          <ArrowPrev />
        </div>
      ) : (
        ''
      )}

      <div className={`ProductModal ${state === true ? 'open' : ''}`}>
        <div className="ProductModal-pattern"></div>

        <div className="ProductModal-close" onClick={closeModalFunction}>
          <Close />
        </div>

        {/* Gallery */}
        <div>
            {state && <Images productId={product.id} defaultImage={product.image} />}
        </div>

        {/* Details */}
        <div className="ProductModal-content">
          <h3 className="ProductModal-title">{product.title}</h3>
          <div className="ProductModal-details">
            {product.meta && product.meta.inspiration && (
              <div>
                <label className="ProductModal-label">Project by:</label>
                <p className="ProductModal-text">
                  {product.meta.inspiration.author}
                </p>
              </div>
            )}

            {product.meta && product.meta.inspiration && (
              <div>
                <label className="ProductModal-label">Material:</label>
                <p className="ProductModal-text">
                  {product.meta.inspiration.material}
                </p>
              </div>
            )}

            <div>
              <label className="ProductModal-label">Finish Color:</label>
              {product.named_tags && (
                <p className="ProductModal-text">{product.named_tags.finish}</p>
              )}
              {product.meta && product.meta.inspiration && (
                <a
                  href={product.meta.inspiration.finish_url}
                  className="ProductModal-link"
                >
                  See More in this Finish Color
                </a>
              )}
            </div>

            <div>
              <label className="ProductModal-label">Style:</label>
              {product.meta && product.meta.inspiration && (
                <p className="ProductModal-text">
                  {product.meta.inspiration.style}
                </p>
              )}
              {product.meta &&
                product.meta.inspiration &&
                product.meta.inspiration.style_url && (
                  <a
                    href={product.meta.inspiration.style_url}
                    className="ProductModal-link"
                  >
                    See More in this style
                  </a>
                )}
            </div>
          </div>

          {product.meta &&
            product.meta.inspiration &&
            product.meta.inspiration.product_url && (
              <div className="ProductModal-btnContainer">
                <a href={product.meta.inspiration.product_url}>
                  <button className="o-button o-button--blue ProductModal-btn">
                    Shop This
                  </button>
                </a>
              </div>
            )}
        </div>
      </div>

      <div
        className={`ProductModal-arrowMobile ${state === true ? 'open' : ''}`}
      >
        {no !== 0 ? (
          <div className="ProductModal-arrowLeftMobile" onClick={goToPrev}>
            <ArrowPrev />
            <span>Previous</span>
          </div>
        ) : (
          <div></div>
        )}
        {all_items_no - 1 !== no ? (
          <div className="ProductModal-arrowRightMobile" onClick={goToNext}>
            <span>Next</span>
            <ArrowNext />
          </div>
        ) : (
          <div></div>
        )}
      </div>

      {all_items_no - 1 !== no ? (
        <div
          className={`ProductModal-arrowRight ${state === true ? 'open' : ''}`}
          onClick={goToNext}
        >
          <ArrowNext />
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
